module.exports = __webpack_public_path__ + "img/like-for-form.b957ca8d.png";